import { generateFullName } from 'utils/generateFullNameUtils';

const generateShortenedActionLabel = (actionCode) => {
  let shortenedActionLabel = '';
  switch (actionCode) {
    case 'ACT_EVENT_CREATE':
      shortenedActionLabel = 'Event';
      break;
    case 'ACT_TASK_CREATE':
      shortenedActionLabel = 'Task';
      break;
    case 'ACT_SEND_TEXT_MESSAGE':
      shortenedActionLabel = 'Text Message';
      break;

    case 'ACT_SEND_SECURE_MESSAGE':
      shortenedActionLabel = 'Secure Message';
      break;
    case 'ACT_BULK_UPLOAD_FOLDER':
      shortenedActionLabel = 'Folder';
      break;
    case 'ACT_CREATE_DOCUMENT':
      shortenedActionLabel = 'Document';
      break;

    default:
      break;
  }

  return shortenedActionLabel;
};

const getSelectedBillingContactsLabels = (selectedBillingContacts) => {
  let labelsArr = [];

  if (selectedBillingContacts?.length) {
    selectedBillingContacts?.forEach((contact, idx) => {
      let label = generateFullName(contact) || '';

      labelsArr?.push(label);
    });
  }

  return labelsArr;
};

const getSelectedTeamMemberLabels = (selectedTeamMember) => {
  // If selectedTeamMember is an array, handle each member
  if (Array.isArray(selectedTeamMember)) {
    return selectedTeamMember.map((member) => {
      const { first_name = '', middle_name = '', last_name = '' } = member;

      // Trim spaces, capitalize, and join non-empty names to form the full name
      const names = [first_name.trim(), middle_name.trim(), last_name.trim()].filter(Boolean); // Removes any empty strings
      // .map(capitalizeString); // Capitalizes each name part

      return names.join(' '); // Joins the names with a space
    });
  }

  // If selectedTeamMember is a single object, handle it directly
  if (selectedTeamMember && typeof selectedTeamMember === 'object') {
    const { first_name = '', middle_name = '', last_name = '' } = selectedTeamMember;

    // Trim spaces, capitalize, and join non-empty names to form the full name
    const names = [first_name.trim(), middle_name.trim(), last_name.trim()].filter(Boolean); // Removes any empty strings
    // .map(capitalizeString); // Capitalizes each name part

    return [names.join(' ')]; // Joins the names with a space and wraps in an array
  }

  // Return an empty array by default if the input is not valid
  return [];
};

const generateFixErrorConfirmDialogMessage = (props) => {
  let confirmationMessage = '';
  const { errorFixDialogData, automationErrorLogCodes, getValues } = props || {};
  const { error_code, user_name, case_name, action_code } = errorFixDialogData || {};

  const {
    userNotInCase,
    noLawftAccess,
    noEmail,
    noBillingContact,
    noPhoneNumber,
    eventTimePassed,
    noLeadAttorney,
    noLeadAssociate,
    noLeadParalegal,
    noLeadCaseManager,
  } = automationErrorLogCodes || {};

  const { email, billingContacts, phoneNumber, teamMembers } = getValues() || {};

  switch (error_code) {
    case userNotInCase:
      confirmationMessage = (
        <>
          <span className="text-bold">{user_name}</span>
          <span> will be added to case</span> <span className="text-bold ms-1">{case_name}</span>
        </>
      );

      break;
    case noLawftAccess:
      confirmationMessage = (
        <>
          <span className="text-bold">{`${user_name} ( ${email} )`}</span>
          <span className="ms-1">will be provided lawft access</span>
        </>
      );

      break;
    case noEmail:
      confirmationMessage = (
        <>
          <span>Email ID </span>
          <span className="text-bold ms-1">{email}</span>
          <span className="ms-1">will be added to user</span>
          <span className="text-bold ms-1"> {user_name}</span>
        </>
      );

      break;
    case noPhoneNumber:
      confirmationMessage = (
        <>
          <span>Phone number</span>
          <span className="text-bold ms-1">{phoneNumber}</span>
          <span>will be updated for</span>
          <span className="text-bold ms-1"> {user_name}</span>
        </>
      );

      break;

    case noBillingContact:
      let billingContactsLabelsArr = getSelectedBillingContactsLabels(billingContacts) || [];

      confirmationMessage = (
        <>
          {/* <span className="text-bold">{billingContactsLabelsArr?.length ? billingContactsLabelsArr.join() : ''}</span> */}
          <span className="text-bold">{billingContactsLabelsArr?.length ? billingContactsLabelsArr.join(', ') : ''}</span>
          <span className="ms-1">
            will be added as
            <span className="text-bold ms-1">billing contact</span> to case
          </span>
          <span className="text-bold ms-1"> {case_name}</span>
        </>
      );

      break;
    case noLeadAttorney:
      let noLeadAttorneyLabelsArr = getSelectedTeamMemberLabels(teamMembers) || [];

      confirmationMessage = (
        <>
          <span className="text-bold">{noLeadAttorneyLabelsArr?.length ? noLeadAttorneyLabelsArr.join() : ''}</span>
          <span className="ms-1">
            will be added as
            <span className="text-bold ms-1">lead attorney</span> to case
          </span>
          <span className="text-bold ms-1"> {case_name}</span>
        </>
      );

      break;
    case noLeadAssociate:
      let noLeadAssociateLabelsArr = getSelectedTeamMemberLabels(teamMembers) || [];

      confirmationMessage = (
        <>
          <span className="text-bold">{noLeadAssociateLabelsArr?.length ? noLeadAssociateLabelsArr.join() : ''}</span>
          <span className="ms-1">
            will be added as
            <span className="text-bold ms-1">lead associate</span> to case
          </span>
          <span className="text-bold ms-1"> {case_name}</span>
        </>
      );

      break;
    case noLeadParalegal:
      let noLeadParalegalLabelsArr = getSelectedTeamMemberLabels(teamMembers) || [];

      confirmationMessage = (
        <>
          <span className="text-bold">{noLeadParalegalLabelsArr?.length ? noLeadParalegalLabelsArr.join() : ''}</span>
          <span className="ms-1">
            will be added as
            <span className="text-bold ms-1">lead paralegal</span> to case
          </span>
          <span className="text-bold ms-1"> {case_name}</span>
        </>
      );

      break;
    case noLeadCaseManager:
      let noLeadCaseManagerLabelsArr = getSelectedTeamMemberLabels(teamMembers) || [];

      confirmationMessage = (
        <>
          <span className="text-bold">{noLeadCaseManagerLabelsArr?.length ? noLeadCaseManagerLabelsArr.join() : ''}</span>
          <span className="ms-1">
            will be added as
            <span className="text-bold ms-1">lead case manager</span> to case
          </span>
          <span className="text-bold ms-1"> {case_name}</span>
        </>
      );

      break;

    case eventTimePassed:
      break;

    default:
      break;
  }

  let messageContent = (
    <div>
      <div className="d-flex align-items-center">
        <i className="p-confirm-dialog-icon pi pi-exclamation-triangle me-3"></i>
        <p className="F-size15">
          {confirmationMessage}
          {[
            'USER_NOT_IN_CASE',
            'NO_LAWFT_ACCESS',
            'NO_EMAIL',
            'NO_BILLING_CONTACT',
            'NO_PHONE_NUMBER',
            'EVENT_TIME_PASSED',
            'NO_LEAD_ATTORNEY',
            'NO_LEAD_ASSOCIATE',
            'NO_LEAD_PARALEGAL',
            'NO_LEAD_CASE_MANAGER',
          ].includes(error_code) ? (
            <span> . Do you want to proceed ?</span>
          ) : (
            <span>Do you want to proceed ?</span>
          )}
        </p>
      </div>
      <div className="px-3 ms-3">
        <p className="fix-error-note">
          <span className="text-bold">Note : </span>
          Fixes applied will be reflected in the upcoming instances of this automation rule.
          <div className="mt-2">Please complete the current action by manually updating the</div>
          <span className="text-bold">{generateShortenedActionLabel(action_code)}</span>
        </p>
      </div>
      <p className="px-3 ms-3"></p>
    </div>
  );

  return messageContent;
};

export default generateFixErrorConfirmDialogMessage;
